/* OTK Sakura hero (sections/otk-sakura-hero.liquid + assets/otk-sakura-hero.css).
   A: frame + door = the closed wall. B: scrolling slides the door into the left wall, showing the rail and caps.
   C: the cherry trees slide in from the screen edges, kept clear of the products. D: petals start, the hero unpins.
   Afterwards the trees stay fixed at the screen edges, petals follow the scroll speed (Lenis velocity) and the
   blossoms thin out with page progress (full -> half -> bare), coming back when scrolling up.
   Lights off until the door opens (section setting): the niche behind the door is dark until the door has slid fully
   open, then its top and floor lights flicker on, and the gust (trees, petals, the rack's wind) follows as they settle.
   The boombox under the sign (assets/otk-boombox.js) is its own layer: this script only treats it like the rack (the
   door's clip and mask, .is-shut, the pan on narrow screens) and keeps the trees clear of it, as of the caps.
   Phones and tablets (section setting "Phone layout", data-fit on the section; the default): on screens narrower than
   the room (aspect under ~1.57, where the view used to pan) the WHOLE room shows, scaled to the screen's width, and
   everything runs exactly as on a laptop: the same timeline, both side walls opening together, no pan. The CSS places
   the room (the stage) under the nav; this script reads its rectangle back (room()) and lays every layer that lives in
   screen space out from it: the rack's rail and caps, the door's clip and mask, the trees (solved in the room's own
   frame px, as on a 1470 x 830 laptop, then scaled down: solve()), the petals (scaled with the room). On portrait
   screens a band under the room (bandMQ) carries the things that would be too small to read at the room's scale: the
   Women's / Men's titles and buttons, the name and price of a tapped piece, the scroll cue. "Close-up with pan" keeps
   the earlier phone layout (the stage cover-cropped, the view panning to each side).
   Needs gsap + ScrollTrigger 3.15.0 and Lenis 1.3.26 (local assets, loaded before this file).
   TREE data comes from scripts/process_hero_assets.py (hero-assets/processed/hero-geometry.json). */
(function () {
  'use strict';

  var TREE = {
    aspect: 1280 / 662,
    trunk: 0.576, // height where the trunk enters the image (sway pivot)
    // 48 x 25 occupancy of the full-bloom tree, used to keep the canopy off the products
    grid: [
      '000000000000000000000000000001100000000000000000',
      '000000000000000000000000000000110000000000000000',
      '000000000000000000011001000001111111100000000000',
      '000000000011000000001111111111111111000000000000',
      '000000000000111000000111111111111110000000000000',
      '000000000000111111111111111111111111111100100000',
      '000000000000011111111111111111111111111101100000',
      '000000000011101111111111111111111111111111000001',
      '000000000011111111111111111111111111111111111100',
      '000000001111111111111111111111111111111111111000',
      '000000001111111111111111111111111111111111000000',
      '000001111100001111010111111111111111111111000000',
      '111111111111011111001111111111111111111111110000',
      '111111111111111100111101111110111111111111110000',
      '111111111111110001111111111011011011111111111000',
      '111111111111110000111111111111111111111111011111',
      '100000000001111001111111111111111111111111100000',
      '000000000001111111111110010101111111111111100000',
      '000000000000111111111111000000111111111110000000',
      '000000000000011111111000000000110000001110000000',
      '000000000000001111111000000000110000011010000000',
      '000000000000000000000000000000100000011100000000',
      '000000000000000000000000000000000000000110000000',
      '000000000000000000000000000000000000011000000000',
      '000000000000000000000000000000000000011000000000'
    ],
    full: [.205,.443,.211,.401,.223,.142,.225,.404,.230,.316,.268,.360,.270,.318,.280,.371,.283,.351,.285,.251,.290,.199,.293,.216,.294,.469,.300,.174,.304,.341,.307,.459,.308,.388,.314,.511,.317,.480,.320,.246,.323,.446,.325,.343,.327,.276,.329,.431,.333,.295,.341,.351,.360,.327,.364,.343,.371,.251,.373,.645,.380,.673,.384,.260,.387,.680,.390,.286,.394,.673,.397,.626,.401,.420,.402,.666,.404,.373,.406,.424,.409,.624,.416,.132,.417,.322,.424,.216,.424,.329,.425,.323,.426,.633,.431,.341,.432,.355,.433,.130,.434,.436,.437,.309,.439,.177,.442,.394,.446,.295,.450,.218,.457,.501,.463,.192,.464,.330,.469,.473,.470,.696,.472,.332,.474,.708,.474,.747,.475,.315,.476,.276,.479,.374,.480,.211,.480,.740,.483,.278,.485,.144,.487,.139,.492,.195,.493,.397,.495,.186,.496,.385,.497,.548,.498,.432,.500,.529,.502,.601,.504,.427,.504,.353,.510,.494,.514,.172,.519,.355,.524,.285,.529,.230,.530,.162,.532,.594,.533,.269,.534,.610,.537,.652,.539,.186,.540,.264,.541,.462,.545,.343,.547,.397,.550,.318,.551,.481,.554,.367,.556,.518,.556,.645,.563,.204,.563,.341,.566,.643,.573,.418,.576,.424,.577,.246,.581,.364,.582,.318,.586,.311,.586,.235,.588,.638,.596,.246,.597,.213,.597,.327,.600,.204,.605,.146,.606,.487,.612,.235,.612,.506,.615,.404,.616,.285,.618,.445,.619,.624,.624,.615,.625,.480,.628,.088,.635,.063,.638,.074,.644,.408,.649,.759,.650,.260,.656,.118,.658,.053,.659,.239,.661,.274,.667,.413,.669,.093,.670,.385,.671,.357,.673,.378,.674,.443,.674,.123,.674,.722,.683,.650,.684,.141,.684,.257,.684,.304,.686,.176,.686,.257,.688,.135,.696,.144,.698,.478,.702,.366,.704,.413,.706,.517,.735,.591,.736,.605,.738,.111,.738,.759,.739,.580,.740,.562,.743,.343,.744,.754,.750,.302,.752,.731,.754,.401,.754,.125,.761,.538,.767,.584,.769,.232,.771,.378,.774,.269,.775,.309,.775,.714,.778,.381,.778,.645,.781,.220,.788,.861,.790,.624,.794,.350,.794,.459,.794,.852,.795,.819,.797,.350,.801,.986,.802,.258,.804,.461,.804,.654,.808,.880,.811,.367,.811,.756,.815,.754,.824,.647,.828,.395,.828,.606,.830,.302,.837,.895,.841,.336,.841,.408,.841,.712,.847,.362,.848,.316,.856,.794,.870,.392,.871,.684,.886,.592,.889,.675,.895,.367,.895,.369,.899,.536,.901,.511,.908,.337,.911,.387,.913,.511,.924,.362,.947,.612,.949,.599,.987,.318],
    half: [.177,.403,.196,.461,.200,.381,.215,.518,.225,.374,.229,.406,.240,.344,.256,.197,.275,.197,.276,.309,.286,.206,.287,.374,.289,.366,.297,.209,.304,.209,.305,.562,.314,.285,.322,.399,.322,.527,.327,.439,.336,.251,.353,.661,.353,.708,.358,.200,.361,.680,.377,.439,.383,.599,.385,.641,.387,.381,.394,.098,.394,.543,.395,.403,.399,.279,.402,.703,.414,.234,.416,.677,.424,.221,.429,.105,.429,.118,.430,.548,.434,.111,.434,.582,.441,.278,.442,.113,.444,.139,.445,.608,.450,.149,.461,.415,.465,.508,.467,.351,.468,.687,.473,.155,.473,.504,.474,.724,.480,.438,.491,.357,.492,.162,.493,.445,.494,.373,.538,.195,.538,.536,.542,.134,.543,.207,.559,.229,.579,.337,.582,.214,.583,.197,.584,.522,.586,.366,.586,.626,.587,.661,.590,.265,.620,.144,.621,.601,.625,.866,.641,.872,.645,.146,.647,.040,.647,.343,.648,.842,.653,.074,.656,.673,.656,.777,.658,.645,.682,.230,.688,.200,.694,.707,.695,.661,.702,.202,.714,.116,.714,.452,.722,.107,.724,.297,.724,.443,.725,.160,.734,.279,.741,.300,.745,.293,.753,.102,.754,.234,.754,.714,.754,.733,.754,.480,.756,.462,.759,.220,.765,.093,.765,.293,.775,.239,.777,.248,.778,.336,.782,.279,.788,.253,.790,.968,.794,.562,.794,.640,.800,.954,.804,.232,.808,.882,.808,.970,.809,.617,.812,.652,.815,.859,.822,.613,.824,.351,.834,.569,.836,.678,.843,.798,.845,.652,.846,.436,.846,.627,.851,.279,.855,.355,.857,.650,.875,.297,.876,.265,.898,.682,.899,.496,.932,.355,.940,.323,.977,.629],
    palette: [[208,158,135],[218,171,168],[228,189,185],[240,203,207],[244,224,232]]
  };

  var FRAME_W = 1376;
  // the sliding door in the frame (px): it slides left into the wall at x 287
  var DOOR = { x: 287, y: 45, w: 800, h: 723 };
  var MASK_PROPS = ['mask-image', 'mask-size', 'mask-position'];
  // the rail as an obstacle for the trees (frame px)
  var RAIL = { x0: 298, y0: 356, x1: 1086, y1: 380 };

  // the side niches behind the slat walls (frame px): x 0-287 and 1089-1376, from y 31
  var SIDE = { w: 287, r: 1089, y: 31 };

  // The niche's lights starting up once the door is open (lights off until the door opens), like a strip light being
  // switched on: a strike, a few stutters, a dip, then steady. [seconds, level 0-1]. Each run is jittered a little (its
  // pace and the in-between levels), and the floor strip runs its own copy a beat after the top one.
  var FLICKER = [[0, 0], [0.03, 0.85], [0.07, 0.08], [0.16, 0.04], [0.19, 0.7], [0.23, 0.12], [0.31, 0.2], [0.34, 1],
    [0.39, 0.35], [0.44, 0.3], [0.47, 0.95], [0.53, 0.55], [0.57, 1], [0.7, 0.86], [0.84, 1]];
  var LIT_SETTLE = { flicker: 600, fade: 400 }; // ms after switching on: the lights have caught, the gust may come
  // the door's progress at or below which the lights switch off again: half shut. Well short of fully open (0.999, where
  // they come on), so scrolling back a little doesn't darken the open room, and a visitor hovering at either point
  // doesn't set them flickering over and over.
  var LIT_OFF_AT = 0.5;
  // The layers that follow the lights (their CSS reads --otk-lit-top / --otk-lit-floor), inside the section, plus
  // anything anywhere marked data-otk-lit (a feature in the niche that dims and brightens with them)
  // (the floor light's spill and pool on the floor in front of the room, and the cove light's wash on the ceiling above
  // it, phones: see the fit mode in the CSS)
  var LIT_LAYERS = '.otk-sakura__dark, .otk-sakura__door-dark, .otk-sakura__uplight, .armory__gl--rack, .armory__caps, ' +
    '.otk-sakura__spill--c, .otk-sakura__spill--pool, .otk-sakura__ceil-glow';

  // Fit mode (phones and tablets, "Whole room, like desktop"): the trees are solved in the room's own frame px, on a
  // 1376 x 768 screen with a laptop's nav over it (64 px on a 1470 x 830 screen, where the room is 1.0807 x its frame)
  var FIT_NAV = 59;
  var FIT_REF_K = 1.0807;

  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  // too narrow to show the side niches (the CSS lengthens the reveal at the same aspect): the view pans to them, or,
  // in fit mode (data-fit), the whole room shows scaled to the width
  var panMQ = window.matchMedia('(max-aspect-ratio: 1567/1000)');
  // fit mode on portrait screens (up to 6:5): room enough under the room for the band (otk-sakura-hero.css)
  var bandMQ = window.matchMedia('(max-aspect-ratio: 6/5)');
  var coarseMQ = window.matchMedia('(pointer: coarse)');

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function smooth(a, b, v) { var t = clamp((v - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function easeInOut(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  // one run of FLICKER: a slightly different pace (+-8%) and in-between levels (+-0.1), the strikes to full kept
  function flickerCurve() {
    var pace = 0.92 + Math.random() * 0.16, last = FLICKER.length - 1;
    return FLICKER.map(function (k, i) {
      var v = k[1];
      if (i > 0 && i < last && v > 0.02 && v < 0.98) v = clamp(v + (Math.random() - 0.5) * 0.2, 0.02, 0.98);
      return [k[0] * pace, v];
    });
  }

  // the level of a flicker run at t seconds (straight lines between its points: a few frames each, so it reads as
  // the abrupt on / off of a strip light)
  function curveAt(c, t) {
    if (t <= 0) return c[0][1];
    for (var i = 1; i < c.length; i++) {
      if (t < c[i][0]) return lerp(c[i - 1][1], c[i][1], (t - c[i - 1][0]) / (c[i][0] - c[i - 1][0]));
    }
    return c[c.length - 1][1];
  }

  /* ---------------------------------------------------------------- smooth scroll (one per page) */
  function getLenis() {
    if (window.OTKLenis) return window.OTKLenis;
    if (!window.Lenis) return null;
    var lenis = new window.Lenis({
      lerp: 0.1,
      smoothWheel: true,
      syncTouch: false,
      allowNestedScroll: true,
      // drawers, modals and the search panel scroll natively
      prevent: function (node) {
        return !!(node && node.closest && node.closest('cart-drawer, menu-drawer, details-modal, predictive-search, .drawer, .menu-drawer, [role="dialog"], [data-lenis-prevent]'));
      }
    });
    lenis.on('scroll', window.ScrollTrigger.update);
    window.gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
    window.gsap.ticker.lagSmoothing(0);
    // the theme locks the page with overflow: hidden on <body> while a drawer is open: pause Lenis meanwhile
    var sync = function () {
      var locked = getComputedStyle(document.body).overflowY === 'hidden';
      if (locked && !lenis.isStopped) lenis.stop();
      else if (!locked && lenis.isStopped) lenis.start();
    };
    new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    window.OTKLenis = lenis;
    return lenis;
  }

  /* ---------------------------------------------------------------- petals */
  function makeSprites(palette, size) {
    var sprites = [];
    var shapes = [[0.62, 1], [0.54, 0.92], [0.7, 0.86]]; // width, length (of size)
    palette.forEach(function (c) {
      shapes.forEach(function (sh) {
        var cv = document.createElement('canvas');
        cv.width = cv.height = size;
        var g = cv.getContext('2d');
        var w = size * sh[0] * 0.5, h = size * sh[1] * 0.5;
        g.translate(size / 2, size / 2);
        g.beginPath();
        g.moveTo(0, -h); // base, where it was attached
        g.bezierCurveTo(w * 1.15, -h * 0.55, w * 1.05, h * 0.6, w * 0.22, h);
        g.lineTo(0, h * 0.74); // the notch at the tip of a cherry petal
        g.lineTo(-w * 0.22, h);
        g.bezierCurveTo(-w * 1.05, h * 0.6, -w * 1.15, -h * 0.55, 0, -h);
        g.closePath();
        var grad = g.createLinearGradient(0, -h, 0, h);
        grad.addColorStop(0, 'rgb(' + Math.round(c[0] * 0.93) + ',' + Math.round(c[1] * 0.78) + ',' + Math.round(c[2] * 0.82) + ')');
        grad.addColorStop(0.45, 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')');
        grad.addColorStop(1, 'rgb(' + Math.min(255, c[0] + 8) + ',' + Math.min(255, c[1] + 14) + ',' + Math.min(255, c[2] + 14) + ')');
        g.fillStyle = grad;
        g.fill();
        g.strokeStyle = 'rgba(150, 80, 95, 0.18)'; // faint centre vein
        g.lineWidth = size / 40;
        g.beginPath();
        g.moveTo(0, -h * 0.85);
        g.lineTo(0, h * 0.55);
        g.stroke();
        sprites.push(cv);
      });
    });
    return sprites;
  }

  /* ---------------------------------------------------------------- hero */
  function Hero(root) {
    this.root = root;
    this.pin = root.querySelector('.otk-sakura__pin');
    this.stage = root.querySelector('.otk-sakura__stage');
    this.door = root.querySelector('.otk-sakura__door');
    this.doorShadow = root.querySelector('.otk-sakura__door-shadow');
    this.hint = root.querySelector('.otk-sakura__hint');
    this.items = []; // the caps (the rack's own, once it has mounted)
    this.rackRoot = root.querySelector('[data-sakura-rack]'); // the live OTK Armory rack, on the photo's rail
    this.titlebar = root.querySelector('[data-sakura-titlebar]'); // its title (logo <-> "One True King")
    // the boombox on its shelf under the sign (snippets/otk-boombox.liquid, assets/otk-boombox.js): its own layer over
    // the rack, the pinned box's size, treated like the rack here: clipped and masked with the door (onDoor), moved with
    // the view on narrow screens (setCam), one of the things the trees keep clear of (productRects)
    this.bb = root.querySelector('[data-otk-boombox]');
    this.bbShut = true; // (as in the markup: see onDoor)
    this.teeScale = (parseFloat(root.dataset.teeScale) || 100) / 100;
    this.doorP = 0;
    this.doorKey = '';
    this.gapsUrl = root.getAttribute('data-door-gaps') || ''; // the slots between the door's slats (alpha mask)
    // the slat walls and the Women's / Men's niches behind them
    this.walls = { l: root.querySelector('.otk-sakura__pocket'), r: root.querySelector('.otk-sakura__wall-r') };
    this.sides = { l: root.querySelector('.otk-sakura__side--l'), r: root.querySelector('.otk-sakura__side--r') };
    this.hasSides = !!(this.sides.l || this.sides.r);
    this.sideP = { l: 0, r: 0 };
    this.sideOpen = 0;
    this.sideAt = {};
    this.cam = { v: 0 }; // -1: looking at the left niche, 1: the right one (narrow screens)
    this.camX = 0;
    this.sideKey = '';
    this.racks = []; // the side niches' rails, when they show the pieces hanging (assets/otk-sakura-racks.js)
    this.fx = root.querySelector('[data-sakura-fx]');
    // fit mode (phones and tablets, see the top of this file): this.fit while the screen is narrow enough, this.band
    // while it is portrait enough for the band under the room. The band's two columns (the Women's / Men's titles and
    // buttons) and the floor light the open side niches throw in front of them follow the walls (onSides: bandSides);
    // its plate shows the piece tapped (or pointed at) on a side wall's rails (bandTag)
    this.fitMode = root.hasAttribute('data-fit');
    this.band = false;
    this.bandEl = root.querySelector('[data-otk-band]');
    this.bandTagEl = this.bandEl && this.bandEl.querySelector('[data-otk-band-tag]');
    // its first line when nothing else is in it (from the door opening on: onDoor), and the sign's words (bandWord)
    this.bandRestEl = this.bandEl && this.bandEl.querySelector('[data-otk-band-rest]');
    this.bandWordEl = this.bandEl && this.bandEl.querySelector('[data-otk-band-word]');
    this.restO = -1;
    this.bandCols = { l: root.querySelector('[data-otk-band-side="l"]'), r: root.querySelector('[data-otk-band-side="r"]') };
    this.spills = { l: root.querySelector('.otk-sakura__spill--l'), r: root.querySelector('.otk-sakura__spill--r') };
    if (this.fitMode && this.titlebar) this.titlebar.classList.add('is-fitmode'); // (it moves out of the section: see the CSS)
    this.syncFit();
    this.scrollLen = (parseFloat(root.dataset.scrollLength) || 260) / 100;
    this.maxPetals = parseInt(root.dataset.petals, 10) || 120;
    this.maxPetalsMobile = parseInt(root.dataset.petalsMobile, 10) || 40;
    this.contentAlpha = (parseFloat(root.dataset.contentAlpha) || 55) / 100;
    this.density = (parseFloat(root.dataset.petalDensity) || 400) / 100; // 1 = the first version's petal flow
    // tree sizes: hero = x the largest size that keeps clear of the products; page = x the first version's corner size
    this.heroScale = (parseFloat(root.dataset.treeScaleHero) || 150) / 100;
    this.pageScale = (parseFloat(root.dataset.treeScalePage) || 150) / 100;
    this.focusIdx = -1;
    this.ptr = null;
    this.keepTrees = root.dataset.keepTrees !== 'false';
    this.st = { treeIn: 0, petalIn: 0 };
    this.petals = [];
    this.vel = 0;
    this.dir = 1;
    this.lastY = window.scrollY;
    this.bloomShown = -1;
    this.halfShown = -1;
    this.frameCount = 0;
    this.listeners = [];
    this.tick = this.tick.bind(this);
    // Lights off until the door opens (section setting, data-lights): the niche's two lights, the cove under its
    // ceiling (in the photo; otk-sakura-niche-dark.webp covers it while off) and the floor light (CSS), stay off while
    // the door is shut and flicker on once it has slid fully open; scrolling back until it's half shut switches them
    // off. H.lit is their state: { on, top, floor } (levels 0-1). Every change is also sent as an 'otk:lights' event
    // on the section (detail { on, top, floor, settled }): once when they switch, every frame while they flicker on or
    // go off, and once settled, so anything else in the niche can dim and brighten with them. In CSS, the section's
    // data-lights (off / anim / on) gives the steady states, and an element marked data-otk-lit also gets the two
    // levels (--otk-lit-top / --otk-lit-floor) written on it while they move. See lights().
    this.litMode = root.hasAttribute('data-lights');
    this.lit = { on: !this.litMode, top: this.litMode ? 0 : 1, floor: this.litMode ? 0 : 1 };
    this.litSettle = 0; // when the lights will have settled after switching on (performance.now() ms)
    this.litTick = this.litTick.bind(this);
    if (this.litMode) root.setAttribute('data-lights', 'off');
    root._otkSakura = this;

    // the band's plate: the name and price of the piece tapped (or pointed at, or focused) on a side wall's rails
    // (assets/otk-sakura-racks.js sends 'otk:rk-tag')
    var self = this;
    if (this.bandTagEl) {
      this.on(root, 'otk:rk-tag', function (e) { self.bandTag(e.detail); });
      // (pressing the plate leaves the focus on the piece, so the plate stays put under the finger until it opens)
      this.on(this.bandTagEl, 'mousedown', function (e) { e.preventDefault(); });
      this.initBandBoxes();
    }
    // A tap on the sign turns it into "One True King" (and the next one back into the logo): the rack engine does it on
    // a click where the screen has no hover (its COARSE), so the same test here keeps the two in step. The sign is
    // small at the room's scale, so the words also show in the band for a few seconds.
    var titleEl = this.titlebar && this.titlebar.querySelector('.armory__title');
    if (this.bandWordEl && titleEl) {
      var noHover = window.matchMedia('(hover: none)').matches;
      this.wordOn = false; // (it starts as the logo)
      this.on(titleEl, 'click', function () {
        if (!noHover) return;
        self.wordOn = !self.wordOn;
        self.bandWord(self.wordOn);
      });
    }

    var animate = !reduceMQ.matches && window.gsap && window.ScrollTrigger;
    if (animate) this.initAnimated();
    else this.initStatic();
  }

  Hero.prototype.on = function (target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    this.listeners.push([target, type, fn, opts]);
  };

  // Fit mode on or off for this screen (the setting, and the screen's shape: the same media queries as the CSS)
  Hero.prototype.syncFit = function () {
    this.fit = this.fitMode && panMQ.matches;
    var band = this.fit && bandMQ.matches;
    if (band !== this.band && !band) this.bandTag(null);
    this.band = band;
  };

  // The room (the stage: the 1376 x 768 frame) in the pinned box's coordinates, and its scale (k: px per frame px).
  // Desktop and the panning phone layout: a "cover" of the pinned box, centred. Fit mode: the CSS puts it under the nav
  // (otk-sakura-hero.css), so it is read back from the page.
  Hero.prototype.room = function () {
    var sw = this.stage.offsetWidth, sh = this.stage.offsetHeight;
    if (!this.fit) return { x: (this.pin.offsetWidth - sw) / 2, y: (this.pin.offsetHeight - sh) / 2, w: sw, h: sh, k: sw / FRAME_W };
    var s = this.stage.getBoundingClientRect(), p = this.pin.getBoundingClientRect();
    return { x: s.left - p.left, y: s.top - p.top, w: s.width, h: s.height, k: s.width / FRAME_W };
  };

  Hero.prototype.roomKey = function (R) {
    return R.x.toFixed(1) + '|' + R.y.toFixed(1) + '|' + R.w.toFixed(1);
  };

  // The OTK logo's height on the sign (the rack engine draws it: embed.logoH; the boombox keeps clear of it): 8% of the
  // hero's height on a laptop (48-80 px), and in fit mode the same share of the room (61 frame px), so the sign keeps
  // its place on the wall
  Hero.prototype.logoH = function (H) {
    return this.fit ? 0.08 * 768 * this.room().k : Math.min(80, Math.max(48, H * 0.08));
  };

  // The band's plate (fit mode, portrait): the side-wall piece being tapped, pointed at or focused (d: its name, price,
  // link and cut-out, from assets/otk-sakura-racks.js), or nothing (null). A link to the piece, as big as a thumb: the
  // garments themselves are small at the room's scale (a second tap on one opens it too).
  Hero.prototype.bandTag = function (d) {
    var el = this.bandTagEl;
    if (!el) return;
    if (!d || !this.band) {
      if (this.tagOn) { el.classList.remove('is-on'); this.tagOn = null; }
      return;
    }
    this.tagOn = d;
    var img = el.querySelector('[data-otk-band-img]');
    el.querySelector('[data-otk-band-name]').textContent = d.name || '';
    el.querySelector('[data-otk-band-price]').textContent = d.price || '';
    if (d.href) el.setAttribute('href', d.href);
    if (img) {
      if (d.img) { if (img.getAttribute('src') !== d.img) img.src = d.img; img.parentNode.hidden = false; }
      else img.parentNode.hidden = true;
    }
    el.classList.add('is-on');
  };

  // The sign's words in the band's first line (fit mode, portrait): for a few seconds after a tap turns the sign into
  // them, unless something tapped takes the line (the CSS)
  Hero.prototype.bandWord = function (on) {
    var el = this.bandWordEl;
    if (!el) return;
    clearTimeout(this.wordT);
    var show = !!on && this.band;
    el.classList.toggle('is-on', show);
    if (show) this.wordT = setTimeout(function () { el.classList.remove('is-on'); }, 3800);
  };

  // The side walls' lit display boxes (shown until their rails are hung, or for good without them): at the room's
  // scale their names can't be read, so on a touch screen, with the band under the room, a first tap on one shows its
  // name and price on the band's plate and a second opens it, as the rails' pieces do (assets/otk-sakura-racks.js).
  // A tap anywhere else (but the plate, which opens it too) lets it go.
  Hero.prototype.initBandBoxes = function () {
    var self = this;
    ['l', 'r'].forEach(function (s) {
      var side = self.sides[s], type = '';
      if (!side) return;
      self.on(side, 'pointerdown', function (e) { type = e.pointerType; }, { passive: true });
      self.on(side, 'click', function (e) {
        var a = e.target.closest && e.target.closest('.otk-sakura__piece');
        var touch = e.detail > 0 && (type === 'touch' || type === 'pen'); // (a keyboard's Enter goes straight through)
        type = '';
        if (!a || !touch || !self.band || (self.tagOn && self.tagOn.box === a)) return;
        e.preventDefault();
        var name = a.querySelector('.otk-sakura__piece-name'), price = a.querySelector('.otk-sakura__piece-price');
        var img = a.querySelector('img');
        self.bandTag({ side: s, box: a, name: name ? name.textContent.trim() : '', price: price ? price.textContent.trim() : '',
          href: a.getAttribute('href'), img: img ? img.currentSrc || img.src : '' });
      });
    });
    this.on(document, 'pointerdown', function (e) {
      var on = self.tagOn;
      if (on && on.box && !on.box.contains(e.target) && !(e.target.closest && e.target.closest('[data-otk-band-tag]'))) self.bandTag(null);
    }, true);
  };

  // The band's two columns follow their walls: shown as a wall starts to open (their opacity is --o, the wall's
  // progress), usable once it is half open (before that they can't be focused or tapped). The open niches' floor light
  // spills onto the floor in front of them the same way.
  Hero.prototype.bandSides = function () {
    var self = this;
    ['l', 'r'].forEach(function (s) {
      var open = self.sides[s] ? Math.round(self.sideP[s] * 100) / 100 : 0;
      var sp = self.spills[s], v = self.fit ? open : 0;
      if (sp && sp._o !== v) { sp._o = v; sp.style.setProperty('--o', String(v)); }
      var col = self.bandCols[s], c = self.band ? open : 0;
      if (!col || col._o === c) return;
      col._o = c;
      col.style.setProperty('--o', String(c));
      col.classList.toggle('is-on', c > 0.01);
      col.inert = c < 0.5;
      if (c < 0.5 && self.tagOn && self.tagOn.side === s) self.bandTag(null); // (its wall closing: the plate goes)
    });
  };

  Hero.prototype.initTrees = function () {
    if (!this.fx) return;
    var self = this;
    this.trees = ['l', 'r'].map(function (side, i) {
      var el = self.fx.querySelector('[data-tree="' + side + '"]');
      return {
        side: side,
        el: el,
        sway: el.querySelector('.otk-sakura-tree__sway'),
        full: el.querySelector('[data-state="full"]'),
        half: el.querySelector('[data-state="half"]'),
        phase: i * 2.1 + 0.4,
        // spring that pushes the tree aside (out to its own edge and up) to uncover the piece being pointed at
        dir: side === 'l' ? [-0.86, -0.51] : [0.86, -0.51],
        pd: 0, // displacement along dir (px)
        pv: 0, // its velocity
        clear: [],
        hero: null,
        page: null,
        pose: null
      };
    });
  };

  /* ------------------------------------------------ reduced motion (or no GSAP): open room, still trees */
  Hero.prototype.initStatic = function () {
    this.root.classList.add('is-static');
    this.static = true;
    this.heroScale = 1; // still trees can't move aside, so keep them clear of the products
    this.doorP = 1;
    if (this.litMode) this.lights(true); // no door to open: the lights are on (at once)
    this.mountRack();
    this.onDoor();
    this.onSides();
    this.mountRacks();
    // fit mode: a tablet turned, or a window resized, between the whole room and the close-up (see initAnimated)
    if (this.fitMode) {
      var refit = function () { this.syncFit(); if (this.placeStatic) this.placeStatic(); else { this.onDoor(); this.onSides(); } }.bind(this);
      this.on(panMQ, 'change', refit);
      this.on(bandMQ, 'change', refit);
    }
    if (!this.fx) {
      this.markCropped();
      this.on(window, 'resize', debounce(function () { this.markCropped(); this.onDoor(); this.onSides(); }.bind(this), 150));
      return;
    }
    this.pin.appendChild(this.fx);
    this.fx.classList.add('otk-sakura-fx--static', 'is-live');
    var canvas = this.fx.querySelector('canvas');
    if (canvas) canvas.remove();
    this.initTrees();
    var self = this;
    var place = this.placeStatic = function () {
      self.markCropped();
      self.onDoor();
      self.onSides();
      self.layout();
      self.trees.forEach(function (t) {
        var d = t.sideClear || 0; // the side walls stand open: keep clear of their displays
        t.el.style.transform = 'translate3d(' + (t.hero.x + t.dir[0] * d) + 'px,' + (t.hero.y + t.dir[1] * d) + 'px,0)';
      });
    };
    place();
    this.on(window, 'resize', debounce(place, 150));
  };

  /* ------------------------------------------------ the scroll sequence */
  Hero.prototype.initAnimated = function () {
    var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger, self = this;
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: true });
    this.lenis = getLenis();
    this.touch = coarseMQ.matches;

    // The lights flicker on when the visitor opens the door. A page that opens (or is restored by the browser) already
    // scrolled past it gets them on at once, with no show: until the visitor's first wheel, touch, press or key, or
    // 1.5 s after the page has loaded (the browser's scroll restoration is done by then), they switch instantly.
    if (this.litMode) {
      var wake = function () { self.litWake = true; };
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (type) { self.on(window, type, wake, { passive: true }); });
      var wakeLater = function () { self.litWakeT = setTimeout(wake, 1500); };
      if (document.readyState === 'complete') wakeLater();
      else this.on(window, 'load', wakeLater);
      // ScrollTrigger sets the door back for a moment while it re-measures (onDoor ignores the lights meanwhile):
      // look again once it's done
      this.litRefresh = function () { self.onDoor(); };
      ScrollTrigger.addEventListener('refresh', this.litRefresh);
    }

    if (this.fx) {
      document.body.appendChild(this.fx); // fixed layer outside the pinned section
      this.initTrees();
      this.canvas = this.fx.querySelector('canvas');
      this.ctx = this.canvas.getContext('2d');
    }

    this.buildTimeline();
    // the screen changes between showing the side niches and panning to them (a tablet turned, a window resized), or,
    // in fit mode, between the whole room and the room as wide as the screen (and between the band under it or not)
    var remq = function () {
      self.syncFit();
      self.buildTimeline();
      ScrollTrigger.refresh(); // (its 'refresh' lays the trees out again: onRefresh)
      self.rebuilding = false;
      self.onDoor();
      self.onSides();
    };
    if (this.hasSides || this.fitMode) this.on(panMQ, 'change', remq);
    if (this.fitMode) this.on(bandMQ, 'change', remq);
    // the title layer goes above the cherry trees (a fixed layer like theirs, the size of the pinned hero), and
    // slides up with the hero as it scrolls away
    if (this.titlebar) {
      document.body.appendChild(this.titlebar);
      this.titlebar.classList.add('is-fixed');
    }
    this.mountRack();
    this.onDoor();
    this.onSides();

    // a keyboard user tabbing onto a product behind the closed door (or out of view while the view is panned to a
    // side): bring it into view first
    this.on(this.root, 'focusin', function (e) {
      if (self.closingViewer || !e.target.closest('.armory__hat, .armory__a11y')) return;
      if (self.tl.time() > 0.42 && Math.abs(self.cam.v) < 0.05) return;
      self.scrollToTime(0.45);
    });
    // ... or onto a piece in a side niche before its wall has opened
    if (this.hasSides) this.on(this.root, 'focusin', function (e) {
      var side = e.target.closest('.otk-sakura__side');
      if (!side || side.hasAttribute('data-rk-refocus')) return; // (the rails taking over a focused box)
      var s = side.getAttribute('data-side'), at = self.sideAt[s];
      var shown = self.sideP[s] > 0.97 && (!self.pan || (s === 'l' ? self.cam.v < -0.97 : self.cam.v > 0.97));
      if (at && !shown) self.scrollToTime(at);
    });

    // where the visitor is pointing, for the trees' spring (mouse: hover; touch: a press, held briefly; keyboard: focus)
    this.on(window, 'pointermove', function (e) {
      if (e.pointerType === 'mouse' || e.pointerType === 'pen') self.ptr = { x: e.clientX, y: e.clientY };
    }, { passive: true });
    this.on(document, 'mouseout', function (e) { if (!e.relatedTarget) self.ptr = null; });
    this.on(window, 'pointerdown', function (e) {
      if (e.pointerType !== 'touch') return;
      clearTimeout(self.touchHold);
      self.ptr = { x: e.clientX, y: e.clientY, touch: true };
    }, { passive: true });
    var release = function (e) {
      if (e.pointerType !== 'touch') return;
      clearTimeout(self.touchHold);
      self.touchHold = setTimeout(function () { self.ptr = null; }, 2500);
    };
    this.on(window, 'pointerup', release, { passive: true });
    this.on(window, 'pointercancel', release, { passive: true });
    this.on(this.root, 'focusin', function (e) {
      var hat = e.target.closest('.armory__hat');
      if (hat) { self.focusIdx = self.prodIndex('cap', self.items.indexOf(hat)); return; }
      var b = e.target.closest('.armory__a11y button'); // the rack's keyboard list: one button per tee, in rack order
      if (b) { self.focusIdx = self.prodIndex('tee', Array.prototype.indexOf.call(b.closest('.armory__a11y').querySelectorAll('button'), b)); return; }
      if (e.target.closest('[data-otk-boombox]')) { self.focusIdx = self.prodIndex('boombox', 0); return; } // (or its next button)
      self.focusIdx = -1;
    });
    this.on(this.root, 'focusout', function () { self.focusIdx = -1; });

    var navCheck = function () {
      var end = self.tl.scrollTrigger.end;
      self.placeTitlebar();
      self.chatAside();
      self.pinNav(window.scrollY > end + 1);
      // a piece left open while scrolling on past the hero closes (it would hide the trees and keep the arrow keys)
      if (self.rack && (self.rack.lifted >= 0 || self.rack.cap) && window.scrollY > end + self.pin.offsetHeight * 0.5) self.rack.closeViewer();
    };
    this.on(window, 'scroll', navCheck, { passive: true });
    navCheck();

    this.markCropped();
    if (!this.fx) {
      this.on(window, 'resize', debounce(function () { self.markCropped(); self.tbTop = null; self.placeTitlebar(); self.onDoor(); self.onSides(); }, 150));
      if (this.hasSides) { // no trees or petals, but the side rails still sway: run the per-frame work for them
        var syncNoFx = function () { self.run(!document.hidden); };
        this.on(document, 'visibilitychange', syncNoFx);
        this.on(window, 'pageshow', syncNoFx);
        syncNoFx();
        var mountLater = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 600); })(function () { self.mountRacks(); }); };
        if (document.readyState === 'complete') mountLater();
        else this.on(window, 'load', mountLater);
      }
      return;
    }
    this.layout();
    this.onRefresh = function () { self.layout(); self.onDoor(); self.onSides(); };
    ScrollTrigger.addEventListener('refresh', this.onRefresh);
    var lastW = window.innerWidth, lastH = window.innerHeight;
    this.on(window, 'resize', debounce(function () {
      self.vh = window.innerHeight;
      self.sizeCanvas();
      self.markCropped();
      self.tbTop = null;
      self.placeTitlebar();
      self.onDoor();
      self.onSides();
      // mobile toolbars change the height a little while scrolling: keep the trees where they are (in fit mode, unless
      // the room has moved: the CSS places it by the small viewport height, which a phone's toolbars don't change, but
      // a desktop window's height does)
      if (window.innerWidth === lastW && Math.abs(window.innerHeight - lastH) < 120 && (!self.fit || self.roomKey(self.room()) === self.roomAt)) return;
      lastW = window.innerWidth;
      lastH = window.innerHeight;
      self.layout();
    }, 150));
    // pause the per-frame work while the tab is hidden (re-checked when a prerendered or bfcache page is shown)
    var sync = function () { self.run(!document.hidden); };
    this.on(document, 'visibilitychange', sync);
    this.on(document, 'prerenderingchange', sync);
    this.on(window, 'pageshow', sync);
    this.on(window, 'focus', sync);
    sync();

    // half / bare blossoms are only needed once the hero is passed, and the side niches' rails only near its end:
    // set them up when the page is idle
    var later = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 600); })(function () { if (self.dead) return; self.loadLater(); self.mountRacks(); }); };
    if (document.readyState === 'complete') later();
    else this.on(window, 'load', later);
  };

  // The side niches' pieces hung on rails (side display "Hanging on rails"): assets/otk-sakura-racks.js cuts each one
  // out of its product shot and hangs it; until it has (or without it) they show as lit display boxes.
  Hero.prototype.mountRacks = function () {
    if (this.dead || this.racksMounted || !this.hasSides) return;
    this.racksMounted = true;
    var self = this; // (the pieces take the low-key grade, --otk-shade, from the section)
    ['l', 'r'].forEach(function (s) {
      var show = self.sides[s] && self.sides[s].querySelector('[data-racks]');
      if (!show || !window.OTK_SAKURA_RACKS) return;
      self.racks.push({ side: s, api: window.OTK_SAKURA_RACKS(show, { side: s, still: !!self.static }) });
    });
  };

  // per frame: the rails' pieces sway with the scroll speed (only while a side niche is open and the hero on screen)
  Hero.prototype.stepRacks = function (dt, time, y) {
    var st = this.tl && this.tl.scrollTrigger;
    if (!this.racks.length || this.sideOpen < 0.01 || (st && y > st.end + this.pin.offsetHeight * 1.05)) return;
    var v = this.vel * this.dir;
    for (var i = 0; i < this.racks.length; i++) {
      var r = this.racks[i];
      if (r.api && r.api.step && this.sideP[r.side] > 0.01) r.api.step(dt, time, v);
    }
  };

  // The scroll timeline (rebuilt when the screen switches between showing the side niches and panning to them).
  // The pin is CSS position: sticky inside a section that already reserves the scroll length (see the CSS): the
  // door's sequence is 1 unit long (scroll length x one screen); the side walls add to it (--otk-span, in the CSS).
  Hero.prototype.buildTimeline = function () {
    var gsap = window.gsap, self = this;
    if (this.tl) {
      this.rebuilding = true; // the door is set back while the new timeline catches up: no gust, no calm
      if (this.tl.scrollTrigger) this.tl.scrollTrigger.kill();
      this.tl.kill();
    }
    var pan = this.pan = this.hasSides && panMQ.matches && !this.fit; // (fit mode: both walls at once, as on desktop)
    var span = 1;
    if (this.hasSides) span = Math.max(pan ? 1.42 : 1.18, parseFloat(getComputedStyle(this.root).getPropertyValue('--otk-span')) || 0);
    this.span = span;
    var tl = gsap.timeline({
      defaults: { ease: 'none' },
      scrollTrigger: {
        trigger: this.root,
        start: 'top top',
        end: function () { return '+=' + Math.round(self.pin.offsetHeight * self.scrollLen * self.span); },
        scrub: this.touch ? 0.5 : true,
        invalidateOnRefresh: true
      }
    });
    if (this.hint) tl.fromTo(this.hint, { autoAlpha: 1 }, { autoAlpha: 0, duration: 0.06 }, 0);
    // B: the door slides into the left wall (slight ease)
    tl.fromTo(this.door, { xPercent: 0 }, { xPercent: -100, ease: 'power1.inOut', duration: 0.4 }, 0.02);
    tl.fromTo(this.doorShadow, { opacity: 0 }, { opacity: 1, duration: 0.06 }, 0.02);
    tl.to(this.doorShadow, { opacity: 0, duration: 0.05 }, 0.36);
    // C + D: once the door is fully open a gust brings the trees in and the petals start (gust(), from onDoor)
    var W = this.walls, L = this.sides.l && W.l, R = this.sides.r && W.r, slide = 'power2.inOut';
    if (!this.hasSides) {
      tl.to({}, { duration: 0.18 }, 0.82); // a beat with everything in place before the hero unpins
      this.sideAt = {};
    } else if (!pan) {
      // E: both slat walls slide out to the sides, to the Women's and Men's niches; then a beat before it unpins
      if (L) tl.fromTo(L, { xPercent: 0 }, { xPercent: -100, duration: 0.15, ease: slide }, 0.8);
      if (R) tl.fromTo(R, { xPercent: 0 }, { xPercent: 100, duration: 0.15, ease: slide }, 0.82);
      tl.to({}, { duration: 0.2 }, span - 0.2);
      this.sideAt = { l: 1.02, r: 1.02 };
    } else {
      // E, narrow screens: the view pans to the left wall and it slides away; then across to the right one
      tl.fromTo(this.cam, { v: 0 }, { v: -1, duration: 0.12, ease: slide }, 0.8);
      if (L) tl.fromTo(L, { xPercent: 0 }, { xPercent: -100, duration: 0.08, ease: slide }, 0.92);
      tl.fromTo(this.cam, { v: -1 }, { v: 1, duration: 0.18, ease: slide, immediateRender: false }, 1.06);
      if (R) tl.fromTo(R, { xPercent: 0 }, { xPercent: 100, duration: 0.08, ease: slide }, 1.24);
      tl.to({}, { duration: 0.1 }, span - 0.1);
      this.sideAt = { l: 1.03, r: 1.37 };
    }
    // the rack shows through the door as it slides; the side niches as their walls do
    tl.eventCallback('onUpdate', function () { self.onDoor(); self.onSides(); });
    this.tl = tl;
  };

  // Scroll to a point of the timeline (in its units)
  Hero.prototype.scrollToTime = function (t) {
    var st = this.tl.scrollTrigger, y = st.start + (st.end - st.start) * t / this.tl.duration();
    if (this.lenis) this.lenis.scrollTo(y, { immediate: true });
    else window.scrollTo(0, y);
  };

  // The side walls and the view: how far each wall has opened (for the trees, and keyboard focus), where the view is
  // panned to on narrow screens, and how much of the niches a cover-scaled screen crops (the displays keep inside it).
  Hero.prototype.onSides = function () {
    if (!this.hasSides) return;
    var gsap = window.gsap, W = this.walls;
    var R = this.room(), sw = R.w, sh = R.h, pw = this.pin.offsetWidth, ph = this.pin.offsetHeight;
    var sx = R.x;
    if (this.static || !gsap) {
      this.sideP = { l: 1, r: 1 };
    } else {
      this.sideP = {
        l: W.l ? clamp(-(parseFloat(gsap.getProperty(W.l, 'xPercent')) || 0) / 100, 0, 1) : 0,
        r: W.r ? clamp((parseFloat(gsap.getProperty(W.r, 'xPercent')) || 0) / 100, 0, 1) : 0
      };
    }
    this.sideOpen = Math.max(this.sides.l ? this.sideP.l : 0, this.sides.r ? this.sideP.r : 0);
    this.chatAside();
    // a wall sliding away stirs the air in front of its rails: the pieces swing out after it
    var last = this.sideLast || { l: 0, r: 0 }, racks = this.racks;
    ['l', 'r'].forEach(function (s) {
      var d = this.sideP[s] - last[s];
      if (!d || this.static) return;
      racks.forEach(function (r) { if (r.side === s && r.api && r.api.kick) r.api.kick(s === 'l' ? -1 : 1, Math.abs(d) * 9); });
    }, this);
    this.sideLast = { l: this.sideP.l, r: this.sideP.r };
    if (this.fitMode) this.bandSides();
    var pan = this.pan && !this.static;
    var crop = pan ? 0 : Math.max(0, -sx), cropY = Math.max(0, (sh - ph) / 2);
    var key = crop.toFixed(1) + '|' + cropY.toFixed(1);
    if (key !== this.sideKey) {
      this.sideKey = key;
      this.stage.style.setProperty('--otk-crop', crop.toFixed(1) + 'px');
      this.stage.style.setProperty('--otk-crop-y', cropY.toFixed(1) + 'px');
      this.racks.forEach(function (r) { if (r.api && r.api.layout) r.api.layout(); });
    }
    var v = pan ? this.cam.v : 0, x = 0;
    if (v < 0) x = -v * Math.max(0, -sx); // the scene moves right: the left niche comes in
    else if (v > 0) x = -v * Math.max(0, sx + sw - pw);
    this.setCam(x);
  };

  // The store's help chat bubble sits in the bottom right corner, over the right display: it steps aside while the
  // side walls are open and the hero is on screen (as on the Armory hero)
  Hero.prototype.chatAside = function () {
    var st = this.tl && this.tl.scrollTrigger;
    var on = !this.static && this.sideOpen > 0.02 && !!st && window.scrollY < st.end + this.pin.offsetHeight * 0.5;
    if (on === this.chatHidden) return;
    this.chatHidden = on;
    document.documentElement.classList.toggle('otk-sakura-sides', on);
  };

  Hero.prototype.setCam = function (x) {
    x = Math.round(x * 10) / 10;
    if (x === this.camX) return;
    this.camX = x;
    this.stage.style.transform = x ? 'translate(calc(-50% + ' + x + 'px), -50%)' : '';
    if (this.rackRoot) this.rackRoot.style.transform = x ? 'translate3d(' + x + 'px,0,0)' : '';
    if (this.bb) this.bb.style.transform = x ? 'translate3d(' + x + 'px,0,0)' : '';
    this.tbTop = null;
    this.placeTitlebar();
    // caps that come into view (or go out of it) can be tapped (or not)
    if (!x || Math.abs(x - (this.camMarked || 0)) > 24) {
      this.camMarked = x;
      this.markCropped();
    }
  };

  Hero.prototype.run = function (on) {
    if (on === this.running) return;
    this.running = on;
    if (on) window.gsap.ticker.add(this.tick);
    else window.gsap.ticker.remove(this.tick);
  };

  Hero.prototype.loadLater = function () {
    var self = this;
    this.fx.querySelectorAll('source[data-srcset]').forEach(function (s) {
      s.srcset = s.getAttribute('data-srcset');
      s.removeAttribute('data-srcset');
    });
    this.fx.querySelectorAll('img[data-src]').forEach(function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
    var half = this.fx.querySelectorAll('[data-state="half"] img, [data-state="bare"] img');
    var pending = half.length;
    half.forEach(function (img) {
      var done = function () { if (--pending === 0) self.laterReady = true; };
      if (img.complete && img.naturalWidth) done();
      else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
    });
  };

  /* ------------------------------------------------ layout: product obstacles + tree poses */
  Hero.prototype.layout = function () {
    if (!this.trees) return;
    var vw = document.documentElement.clientWidth, vh = window.innerHeight;
    this.vw = vw;
    this.vh = vh;
    this.mobile = vw < 750;
    this.navH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--otk-nav-h')) || 0;
    var bar = document.querySelector('.section-header .header-wrapper');
    this.barH = bar ? bar.getBoundingClientRect().height : this.navH; // the glass nav as drawn

    // where the stage sits while the hero is pinned (pin box at the top of the viewport)
    var R = this.room(), sx = R.x, sy = R.y, k = R.k;
    var m = this.mobile ? 4 : 8;
    var prods = this.productRects(sx, sy);
    // (the boombox under the sign is one of them: on portrait phones and 16:10 / 4:3 screens the canopies would sit
    // right on it; kept off it, they still arch over the sign, just a little higher)
    var obs = prods.map(function (r) { return { x0: r.x0 - m, y0: r.y0 - m, x1: r.x1 + m, y1: r.y1 + m }; });
    obs.push({ x0: sx + RAIL.x0 * k, y0: sy + RAIL.y0 * k, x1: sx + RAIL.x1 * k, y1: sy + RAIL.y1 * k });
    // products cropped out of view (narrow screens) don't constrain the trees
    var ph = this.pin.offsetHeight;
    obs = obs.filter(function (o) { return o.x1 > 0 && o.x0 < vw && o.y1 > 0 && o.y0 < ph; });
    // Fit mode: the trees are laid out in the room's own frame px, as on a laptop (a 1376 x 768 screen under a laptop's
    // nav: FIT_NAV), then scaled down onto the room, so they frame it exactly as on desktop. Their obstacles are the
    // same products, in frame px (8 frame px of margin, as on a laptop), and the rail.
    var V = null, obsF = null;
    if (this.fit) {
      V = { w: FRAME_W, h: 768, navH: FIT_NAV, mobile: false };
      obsF = prods.map(function (r) { return { x0: (r.x0 - sx) / k - 8, y0: (r.y0 - sy) / k - 8, x1: (r.x1 - sx) / k + 8, y1: (r.y1 - sy) / k + 8 }; });
      obsF.push({ x0: RAIL.x0, y0: RAIL.y0, x1: RAIL.x1, y1: RAIL.y1 });
      obsF = obsF.filter(function (o) { return o.x1 > 0 && o.x0 < V.w && o.y1 > 0 && o.y0 < V.h; });
      this.roomAt = this.roomKey(R);
    }
    this.R = R;
    // fit mode with the band under the room: the trees come back to the page's top corners only once the band's
    // buttons have scrolled up past where they settle (just under the nav), or they would settle right on top of them
    // as the visitor reaches for them: the scroll (px past the hero's end) to wait for, see tick
    this.bandDelay = 0;
    var cols = this.band && this.bandEl && this.bandEl.querySelector('.otk-sakura__band-sides');
    if (cols) this.bandDelay = Math.max(0, cols.getBoundingClientRect().bottom - this.pin.getBoundingClientRect().top - (this.barH || 0) - 60);
    // petals scale with the room in fit mode (a laptop's room is 1.08 x its frame), down to a size that still reads
    this.pk = this.fit ? Math.max(0.45, k / FIT_REF_K) : 1;

    // the products themselves (no margin), in the same pinned-viewport coordinates
    this.prods = prods;

    // once the side walls open the trees part right off the screen (up and out), leaving the whole boutique clear;
    // they come back to the top corners as the hero scrolls away
    var self = this, screen = { x0: 0, y0: 0, x1: this.pin.offsetWidth, y1: ph };
    this.trees.forEach(function (t) {
      if (V) {
        var f = self.grow(t.side, self.solve(t.side, obsF, V), self.heroScale, V.w);
        t.hero = { x: sx + f.x * k, y: sy + f.y * k, w: f.w * k };
      } else {
        t.hero = self.grow(t.side, self.solve(t.side, obs), self.heroScale);
      }
      t.page = self.pagePose(t.side, t.hero);
      t.el.style.width = t.hero.w.toFixed(1) + 'px';
      t.clear = self.prods.map(function (r) { return self.clearance(t, r); });
      t.sideClear = self.hasSides ? self.clearance(t, screen) : 0;
    });

    if (this.canvas) {
      this.sizeCanvas();
      if (!this.sprites) this.sprites = makeSprites(TREE.palette, 48);
      this.limit = this.mobile ? this.maxPetalsMobile : this.maxPetals;
    }
    this.maxScroll = window.ScrollTrigger ? window.ScrollTrigger.maxScroll(window) : document.documentElement.scrollHeight - vh;
  };

  Hero.prototype.sizeCanvas = function () {
    if (!this.canvas) return;
    var w = this.fx.clientWidth, h = this.fx.clientHeight;
    var dpr = Math.min(window.devicePixelRatio || 1, this.vw < 750 ? 1.5 : 2);
    if (w === this.cw && h === this.ch && dpr === this.dpr) return;
    this.dpr = dpr;
    this.cw = w;
    this.ch = h;
    this.canvas.width = Math.round(w * dpr);
    this.canvas.height = Math.round(h * dpr);
  };

  // Products cropped out of the cover-scaled stage (narrow screens) can't be seen or tapped: take them out of the
  // tab order and the accessibility tree too.
  Hero.prototype.markCropped = function () {
    var pr = this.pin.getBoundingClientRect();
    this.items.forEach(function (li) {
      var r = li.getBoundingClientRect();
      li.inert = r.right <= pr.left + 4 || r.left >= pr.right - 4;
    });
  };

  // The rack's caps and tees, in pinned-viewport coordinates (the rack's box is the pinned hero).
  Hero.prototype.productRects = function (sx, sy) {
    var out = [], api = this.rack;
    if (api) {
      var rr = this.rackRoot.getBoundingClientRect();
      this.items.forEach(function (a, j) {
        var r = a.getBoundingClientRect();
        out.push({ kind: 'cap', key: j, el: a, x0: r.left - rr.left, y0: r.top - rr.top, x1: r.right - rr.left, y1: r.bottom - rr.top });
      });
      var L = api.layout;
      api.G.forEach(function (g) {
        if (!g.visible || g.kind !== 'tee') return;
        // a hovered tee turns to face you: keep clear of its full front width
        var half = Math.max(g.wF || 0, g.wS || 0) / 2, x = g.rest != null ? g.rest : g.x;
        out.push({ kind: 'tee', key: g.i, x0: x - half, y0: L.railY - L.railRad * 3, x1: x + half, y1: L.railY + L.hangDrop + g.h });
      });
    } else if (this.rackRoot) { // still loading: keep clear of the stands and of the stretch where the tees will hang
      var W = this.pin.offsetWidth, H = this.pin.offsetHeight, e = this.railGeom(W, H), c = this.capsGeom(W, H);
      ['l', 'r'].forEach(function (side) {
        c.stands[side].forEach(function (at) {
          out.push({ kind: 'band', key: -1, x0: at.x - 0.6 * c.size, y0: at.y - 0.15 * c.size, x1: at.x + 0.4 * c.size, y1: at.y + 0.6 * c.size });
        });
      });
      out.push({ kind: 'band', key: -1, x0: e.left, y0: e.y - e.rad * 3, x1: e.right, y1: e.y + e.S * 1.05 });
    }
    // the boombox under the sign: the trees keep clear of it too, and swing aside when the pointer (or focus) is on it
    // (not when there was no room for it under the sign and it has stepped out of the room: .is-cramped)
    var bbBtn = this.bb && this.rackRoot && !this.bb.classList.contains('is-cramped') && this.bb.querySelector('[data-otk-bb-btn]');
    if (bbBtn) {
      var br = bbBtn.getBoundingClientRect(), rb = this.rackRoot.getBoundingClientRect();
      if (br.width) out.push({ kind: 'boombox', key: 0, el: bbBtn, x0: br.left - rb.left, y0: br.top - rb.top, x1: br.right - rb.left, y1: br.bottom - rb.top });
    }
    return out;
  };

  Hero.prototype.prodIndex = function (kind, key) {
    var list = this.prods || [];
    for (var i = 0; i < list.length; i++) if (list[i].kind === kind && list[i].key === key) return i;
    return -1;
  };

  /* ------------------------------------------------ the live rack on the photo's rail */
  // The rail in the frame: end caps at x 302 / 1080, hooks between 318 and 1064, centre line y 367.5, about 11px thick.
  // Tee size (S, the engine's unit: about a tee's length) is set to the room's scale; on narrow screens it shrinks so
  // at least four tees fit the visible stretch of rail. W, H: the rack's box (= the pinned hero).
  // Fit mode: the room as it is (no smallest tee size, a thinner rail allowed), so the same tees hang as on desktop.
  Hero.prototype.railGeom = function (W, H) {
    var R = this.fit ? this.room() : null;
    var sw = R ? R.w : this.stage.offsetWidth, sh = R ? R.h : this.stage.offsetHeight, k = sw / FRAME_W;
    var sx = R ? R.x : (W - sw) / 2, sy = R ? R.y : (H - sh) / 2;
    var left = Math.max(sx + 318 * k, 14), right = Math.min(sx + 1064 * k, W - 14);
    var pack = 0.36, ends = 1.1, len = Math.max(60, right - left);
    var S = Math.max(R ? 0 : 70, Math.min(205 * k * this.teeScale, len / (4 * pack + ends)));
    return { left: left, right: right, y: sy + 367.5 * k, rad: Math.max(R ? 1 : 2.5, 5.5 * k), S: S, pack: pack, ends: ends };
  };

  // The shelves and stands in the frame: stand heads at x 389 / 473 (left) and 902 / 993 (right), top at y 214, where
  // a cap's pivot rests; caps 84px wide. Each shelf's box (cap tops to the shelf's front edge) carries its hover label.
  Hero.prototype.capsGeom = function (W, H) {
    var R = this.fit ? this.room() : null;
    var sw = R ? R.w : this.stage.offsetWidth, sh = R ? R.h : this.stage.offsetHeight, k = sw / FRAME_W;
    var sx = R ? R.x : (W - sw) / 2, sy = R ? R.y : (H - sh) / 2;
    var pt = function (x) { return { x: sx + x * k, y: sy + 214 * k }; };
    var box = function (x0, x1) { return { x: sx + x0 * k, y: sy + 186 * k, w: (x1 - x0) * k, h: (305 - 186) * k }; };
    return {
      size: 84 * k,
      stands: { l: [pt(389), pt(473)], r: [pt(902), pt(993)] },
      shelves: { l: box(295, 542), r: box(840, 1086) }
    };
  };

  Hero.prototype.mountRack = function () {
    var self = this, el = this.rackRoot;
    if (!el || this.rackP || !window.OTK_SAKURA_RACK_MOUNT) return;
    var sv = parseFloat(getComputedStyle(this.root).getPropertyValue('--otk-shade')), shade = isNaN(sv) ? 0.55 : sv;
    var tb = this.titlebar;
    // the title sits above the rack's box: hovering it still moves the gold's light, as on the rack
    if (tb) this.on(tb, 'pointermove', function (e) {
      el.dispatchEvent(new PointerEvent('pointermove', { clientX: e.clientX, clientY: e.clientY, pointerType: e.pointerType, bubbles: true }));
    }, { passive: true });
    var embed = {
      rail: function (W, H) { return self.railGeom(W, H); },
      caps: function (W, H) { return self.capsGeom(W, H); },
      titleEl: tb && tb.querySelector('.armory__title'),
      titleFx: tb && tb.querySelector('.armory__title-fx'),
      titleCanvas: tb && tb.querySelector('.otk-sakura__title-gl'),
      lightX: 0.5, // the cove light above the niche
      env: [[0.95, 0.8, 0.6], [0.3, 0.29, 0.28], [0.07, 0.07, 0.08], 0.2], // what the chrome hooks reflect: warm light above, the dim room
      tone: [1 - 0.18 * shade, 1 - 0.21 * shade, 1 - 0.25 * shade], // dimmer and warmer for the low-key light (section setting)
      // the logo on the sign: in fit mode at the room's scale (see logoH)
      logoH: function (W, H) { return self.logoH(H); },
      // the tees' and the sign's canvases: in fit mode on a phone (the room under 0.45 of its frame's size) they are small
      // on a sharp screen, so drawn at up to 2 px per CSS px; a tablet's room is big enough for the engine's own
      // (0: the engine's own, 1.5 on touch screens)
      pixelRatio: function () { return self.fit && self.room().k < 0.45 ? Math.min(window.devicePixelRatio || 1, 2) : 0; },
      // a piece opened while the hero is partly scrolled away: bring the whole hero back on screen first
      reveal: function () {
        var st = self.tl && self.tl.scrollTrigger;
        if (!st) { self.pin.scrollIntoView({ block: 'start' }); return; }
        if (self.pan) { self.scrollToTime(0.6); return; } // the view faces the rack again
        if (self.lenis) self.lenis.scrollTo(st.end);
        else window.scrollTo(0, st.end);
      }
    };
    this.rackP = window.OTK_SAKURA_RACK_MOUNT(el, embed).then(function (api) {
      if (!api) return;
      if (self.dead) { api.destroy(); return; }
      self.rack = api;
      self.items = Array.prototype.slice.call(el.querySelectorAll('.armory__hat'));
      self.markCropped();
      if (self.trees) {
        self.layout();
        if (self.placeStatic) self.placeStatic(); // still trees: move them to the new layout too
      }
      // the cherry trees step back while a piece is open in the viewer
      self.viewObs = new MutationObserver(function () {
        document.documentElement.classList.toggle('otk-sakura-viewing', el.classList.contains('is-open'));
      });
      self.viewObs.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  };

  // The rack shows only through the opening and, while the door is in the way, through the slots between its slats:
  // a clip at the wall the door slides into, plus a mask of the opening (right of the door's leading edge) and the
  // slots (otk-sakura-door-gaps.webp, carried along with the door). Until the door is open nothing on the wall can be
  // pointed at.
  Hero.prototype.onDoor = function () {
    var p = 1;
    if (!this.static && this.door && window.gsap) p = clamp(-(parseFloat(window.gsap.getProperty(this.door, 'xPercent')) || 0) / 100, 0, 1);
    this.doorP = p;
    // the band's resting line (fit mode, portrait) comes up as the door finishes opening
    if (this.bandRestEl) {
      var rest = this.band ? Math.round(smooth(0.6, 1, p) * 100) / 100 : 0;
      if (rest !== this.restO) { this.restO = rest; this.bandRestEl.style.setProperty('--rest', String(rest)); }
    }
    var el = this.rackRoot;
    if (!el) return;
    var R = this.room(), sh = R.h, k = R.k, sx = R.x, sy = R.y;
    var wall = Math.max(0, sx + DOOR.x * k);
    var left = sx + (DOOR.x - DOOR.w * p) * k, right = left + DOOR.w * k; // the door, where it is now
    var slots = p < 1 && this.gapsUrl;
    var clip = slots || p >= 1 ? wall : Math.max(0, right); // (no mask file: only the opening shows)
    // with side niches the rack also stops at the right wall (they lie under it and can be pointed at)
    var clipR = this.hasSides ? Math.max(0, this.pin.offsetWidth - (sx + SIDE.r * k)) : 0;
    var mask = slots ? [
      Math.max(0, this.pin.offsetWidth - right).toFixed(1) + 'px 100%, ' + (DOOR.w * k).toFixed(1) + 'px ' + (DOOR.h * k).toFixed(1) + 'px',
      right.toFixed(1) + 'px 0, ' + left.toFixed(1) + 'px ' + (sy + DOOR.y * k).toFixed(1) + 'px'
    ] : null;
    // screens that pan to the side niches (phones, tablets): the rack's box is only the screen, but the view pans across
    // the whole room, so once the door is open the rack draws outside its box too (the caps on the stands beyond the
    // screen edges come into view with the pan; the pin still trims everything to the screen)
    var free = !!this.pan && !this.static && p >= 1;
    // fit mode, portrait (the band under the room): once the door is open, the rack's and the boombox's layers also
    // draw in the band below the room, across the whole width (the tees' and caps' names, the track's name and its next
    // button move there: otk-sakura-hero.css, otk-boombox.css); the side niches stay uncovered above it
    var band = this.band && p >= 1, rb = sy + sh;
    var key = clip.toFixed(1) + '|' + clipR.toFixed(1) + (mask ? '|' + mask.join('|') : '') + (free ? '|free' : '') + (band ? '|band' + rb.toFixed(1) : '');
    if (key !== this.doorKey) {
      this.doorKey = key;
      el.style.overflow = free ? 'visible' : '';
      // the rack, the title (its own layer, the same box) and the boombox's layer all show only through the opening and
      // the slots
      var img = mask ? 'linear-gradient(#000, #000), url("' + this.gapsUrl + '")' : null;
      var inset = 'inset(0 ' + clipR.toFixed(1) + 'px 0 ' + clip.toFixed(1) + 'px)', tb = this.titlebar;
      var poly = band ? 'polygon(' + clip.toFixed(1) + 'px 0, calc(100% - ' + clipR.toFixed(1) + 'px) 0, calc(100% - ' + clipR.toFixed(1) + 'px) ' +
        rb.toFixed(1) + 'px, 100% ' + rb.toFixed(1) + 'px, 100% 100%, 0 100%, 0 ' + rb.toFixed(1) + 'px, ' + clip.toFixed(1) + 'px ' + rb.toFixed(1) + 'px)' : '';
      [el, tb, this.bb].forEach(function (layer) {
        if (!layer) return;
        var s = layer.style;
        s.clipPath = free && layer === el ? 'none' : band && layer !== tb ? poly : inset;
        MASK_PROPS.forEach(function (prop, i) {
          var v = i === 0 ? img : mask && mask[i - 1];
          if (v) {
            s.setProperty('-webkit-' + prop, v);
            s.setProperty(prop, v);
          } else {
            s.removeProperty('-webkit-' + prop);
            s.removeProperty(prop);
          }
        });
      });
    }
    // the door has opened all the way: a gust brings the trees in; closing it again sends them back.
    // Lights off until the door opens: fully open switches the niche's lights on (they flicker on) and the gust waits
    // for them to settle (gustSoon); closed back to half shut (LIT_OFF_AT) switches them off, so the next opening
    // flickers again. The gap between the two (0.5 / 0.999) keeps a visitor hovering at either point from setting them
    // flickering over and over. Not while ScrollTrigger re-measures (it sets the door back for a moment; litRefresh
    // looks again after).
    if (!this.static && this.tl && !this.rebuilding) {
      if (this.litMode && !window.ScrollTrigger.isRefreshing) {
        if (p >= 0.999 && !this.lit.on) this.lights(true);
        else if (p <= LIT_OFF_AT && this.lit.on) this.lights(false);
      }
      if (p >= 0.995 && !this.gusted && (!this.litMode || this.lit.on)) this.gustSoon();
      else if (p < 0.9 && this.gusted) this.calmTrees();
    }
    var shut = p < 0.97;
    if (shut !== this.shut) {
      el.classList.toggle('is-shut', shut);
      this.shut = shut;
    }
    // The boombox (otk-boombox.js makes it inert while .is-shut) opens with the rack, once the door is open, but stays
    // open until the door, sliding back, actually reaches it: it stands in the middle of the niche, in plain view and
    // lit until the door is more than 40% shut, and while it plays it must be pressable there (its "now playing" pill
    // only takes over once it is covered). Its left edge comes from its script (frame px: smaller on short, wide
    // screens); the door's leading edge is at DOOR.x + DOOR.w * (1 - p).
    if (this.bb) {
      var bbApi = this.bb._otkBoombox, bbLeft = bbApi && bbApi.frameLeft ? bbApi.frameLeft : 608;
      var bbShut = this.bbShut ? shut : p < 1 - (bbLeft - DOOR.x) / DOOR.w;
      if (bbShut !== this.bbShut) {
        this.bbShut = bbShut;
        this.bb.classList.toggle('is-shut', bbShut);
      }
    }
    if (shut && this.rack && (this.rack.lifted >= 0 || this.rack.cap)) { // scrolled back into the door: the viewer goes with it
      this.closingViewer = true; // (its focus return must not pull the page back to the open door)
      this.rack.closeViewer();
      this.closingViewer = false;
    }
  };

  // The title layer is the pinned hero's size (CSS) and follows it: still while pinned, then up with it as it scrolls away.
  Hero.prototype.placeTitlebar = function () {
    var tb = this.titlebar, st = this.tl && this.tl.scrollTrigger;
    if (!tb || !st || !tb.classList.contains('is-fixed')) return;
    var y = window.scrollY, top = y < st.start ? st.start - y : y > st.end ? st.end - y : 0;
    if (top === this.tbTop) return;
    this.tbTop = top;
    tb.style.transform = 'translate3d(' + (this.camX || 0) + 'px,' + top.toFixed(1) + 'px,0)';
    tb.style.visibility = top < -this.pin.offsetHeight ? 'hidden' : '';
  };

  // The door-open gust: it sweeps along the rail (the rack's own gust: tees swing and twist, caps rock), carries the
  // cherry trees in from the screen edges (they bend with it and spring back), and a rush of blossoms comes with it.
  // landed: the page was already past the hero when the door opened (it loaded or was restored there): the trees are
  // simply in place. (Decided when the door opened, not now: see gustSoon.)
  Hero.prototype.gust = function (landed) {
    var gsap = window.gsap, st = this.st;
    this.gusted = true;
    gsap.killTweensOf(st);
    if (landed) { st.treeIn = 1; st.petalIn = 1; return; }
    if (this.rack && this.rack.blow) this.rack.blow(1, 2);
    if (!this.trees) return;
    gsap.to(st, { treeIn: 1, duration: 1.3, ease: 'none' }); // eased out in tick()
    gsap.to(st, { petalIn: 1, duration: 0.6, delay: 0.5, ease: 'none' });
    this.trees.forEach(function (t) { t.leanV = (t.leanV || 0) + 62; });
    this.burst = { age: 0, acc: 0, dir: 1, total: (this.mobile ? 80 : 260) * this.density / 4 };
  };

  // The gust, once the lights have settled when they've just flickered on (lights off until the door opens): about
  // 0.6 s after the door is fully open, as the last stutter fades, instead of on the very frame it opens. At once
  // without the setting, or when the lights were already on (or came on instantly).
  // Whether the page landed past the hero is decided here, on the frame the door opens, as without the delay: a
  // visitor who flicks through the door and past the hero within those 0.6 s still gets the whole gust (the trees ride
  // in, the blossoms rush), it just comes as the lights settle.
  Hero.prototype.gustSoon = function () {
    var self = this, wait = this.litMode ? (this.litSettle - performance.now()) / 1000 : 0;
    var landed = window.scrollY > this.tl.scrollTrigger.end;
    if (wait <= 0.02 || landed) { this.gust(landed); return; }
    this.gusted = true; // (closing the door again first cancels it: calmTrees)
    if (this.gustCall) this.gustCall.kill();
    this.gustCall = window.gsap.delayedCall(wait, function () { self.gustCall = null; self.gust(false); });
  };

  Hero.prototype.calmTrees = function () {
    var gsap = window.gsap;
    this.gusted = false;
    this.burst = null;
    if (this.gustCall) { this.gustCall.kill(); this.gustCall = null; }
    gsap.killTweensOf(this.st);
    gsap.to(this.st, { treeIn: 0, duration: 0.9, ease: 'power1.in' });
    gsap.to(this.st, { petalIn: 0, duration: 0.3 });
  };

  /* ------------------------------------------------ lights off until the door opens */
  // Switch the niche's lights on (a flicker, then steady: FLICKER, the floor strip catching 80-150 ms after the top) or
  // off (0.15 s, like a switch). Instant when there is nothing to watch: the static room, a page that opened (or was
  // restored) already past the door before the visitor did anything, the hero already scrolled away, a hidden tab.
  // Reduced motion: no flicker, a plain 0.4 s fade.
  Hero.prototype.lights = function (on) {
    var lit = this.lit, st = this.tl && this.tl.scrollTrigger, now = performance.now();
    lit.on = on;
    var a = { on: on, t0: now, top0: lit.top, floor0: lit.floor };
    if (this.static || !this.litWake || document.hidden || (st && window.scrollY > st.end)) a.kind = 'set';
    else if (!on) { a.kind = 'fade'; a.dur = 0.15; }
    else if (reduceMQ.matches) { a.kind = 'fade'; a.dur = 0.4; }
    else { a.kind = 'flicker'; a.top = flickerCurve(); a.floor = flickerCurve(); a.lag = 0.08 + Math.random() * 0.07; }
    // the gust (trees, petals, the rack's wind) waits until they have caught
    this.litSettle = on ? now + (LIT_SETTLE[a.kind] || 0) : 0;
    this.litAnim = a;
    if (a.kind === 'set') { this.setLit(0, 0, true); return; }
    // from here the two levels are written inline on the layers that use them (they start from where they are) until
    // they settle; the section's data-lights="anim" holds the rest of it at off meanwhile
    this.litWrite(null);
    this.litEls = Array.prototype.slice.call(this.root.querySelectorAll(LIT_LAYERS))
      .concat(Array.prototype.slice.call(document.querySelectorAll('[data-otk-lit]')));
    this.litWrite(lit.top, lit.floor);
    this.root.setAttribute('data-lights', 'anim');
    this.litEmit(false);
    window.gsap.ticker.add(this.litTick);
    this.litTick();
  };

  // per frame while the lights move (time-based, not scrubbed: it plays out the same however the visitor scrolls)
  Hero.prototype.litTick = function () {
    var a = this.litAnim;
    if (!a) return;
    var t = (performance.now() - a.t0) / 1000, top, floor, done;
    if (a.kind === 'flicker') {
      top = curveAt(a.top, t);
      floor = curveAt(a.floor, t - a.lag);
      done = t - a.lag >= a.floor[a.floor.length - 1][0];
    } else {
      var k = clamp(t / a.dur, 0, 1), e = a.on ? smooth(0, 1, k) : easeOut(k), to = a.on ? 1 : 0;
      top = lerp(a.top0, to, e);
      floor = lerp(a.floor0, to, e);
      done = k >= 1;
    }
    this.setLit(top, floor, done);
  };

  // Write the levels while they move, and tell anyone listening. Once settled the steady state goes back to the CSS
  // (data-lights off / on, see otk-sakura-hero.css) and nothing more is written until the next switch.
  Hero.prototype.setLit = function (top, floor, done) {
    var lit = this.lit;
    if (done) {
      top = floor = lit.on ? 1 : 0;
      this.litAnim = null;
      if (window.gsap) window.gsap.ticker.remove(this.litTick);
      this.litWrite(null);
      this.root.setAttribute('data-lights', lit.on ? 'on' : 'off');
    } else if (top !== lit.top || floor !== lit.floor) {
      this.litWrite(top, floor);
    } else {
      return;
    }
    lit.top = top;
    lit.floor = floor;
    this.litEmit(done);
  };

  // the two levels on the layers that follow the lights (litEls, gathered when they start to move), or off them again
  // (null): a handful of elements restyled per frame, where the same two properties on the section would restyle all
  // of its hundreds
  Hero.prototype.litWrite = function (top, floor) {
    var els = this.litEls;
    if (!els) return;
    for (var i = 0; i < els.length; i++) {
      var s = els[i].style;
      if (top === null) {
        s.removeProperty('--otk-lit-top');
        s.removeProperty('--otk-lit-floor');
      } else {
        s.setProperty('--otk-lit-top', top.toFixed(3));
        s.setProperty('--otk-lit-floor', floor.toFixed(3));
      }
    }
    if (top === null) this.litEls = null;
  };

  Hero.prototype.litEmit = function (settled) {
    var lit = this.lit;
    // (it bubbles, so a layer the script has moved out of the section can listen on the document)
    this.root.dispatchEvent(new CustomEvent('otk:lights', { bubbles: true, detail: { on: lit.on, top: lit.top, floor: lit.floor, settled: settled } }));
  };

  // Largest, best-placed tree that touches its screen edge and keeps every canopy cell off the products and rail.
  // V: the screen to solve on (fit mode: the room's frame, { w, h, navH, mobile }); the pinned hero's box without it.
  Hero.prototype.solve = function (side, obs, V) {
    var vw = V ? V.w : this.vw, vh = V ? V.h : this.pin.offsetHeight, mobile = V ? V.mobile : this.mobile, navH = V ? V.navH : this.navH;
    var grid = TREE.grid, rows = grid.length, cols = grid[0].length;
    if (!TREE.cells) {
      TREE.cells = [];
      for (var r = 0; r < rows; r++) for (var c = 0; c < cols; c++) if (grid[r][c] === '1') TREE.cells.push(c, r);
    }
    var cells = TREE.cells, n = cells.length / 2;
    var bx0 = Infinity, by0 = Infinity, bx1 = -Infinity, by1 = -Infinity;
    obs.forEach(function (o) { bx0 = Math.min(bx0, o.x0); by0 = Math.min(by0, o.y0); bx1 = Math.max(bx1, o.x1); by1 = Math.max(by1, o.y1); });

    var wMax = mobile ? vw * 1.05 : Math.min(vw * 0.6, 1150);
    var wMin = mobile ? vw * 0.55 : Math.max(vw * 0.24, 300);
    var reach = vw * (mobile ? 0.84 : 0.57);              // how far across the screen a canopy may reach
    var prefer = side === 'l' ? (mobile ? 0.2 : 0.22) : (mobile ? 0.36 : 0.3); // trunk height (of vh): staggered
    var best = null;
    for (var step = 0; step <= 12; step++) {
      var w = lerp(wMax, wMin, step / 12), h = w / TREE.aspect, cw = w / cols, ch = h / rows;
      for (var off = 0; off <= 0.36; off += 0.06) {
        var x = side === 'l' ? -off * w : vw - w + off * w;
        if ((side === 'l' ? x + w : vw - x) > reach) continue;
        for (var yi = 0; yi <= 40; yi++) {
          var y = lerp(-0.5 * h, vh * 0.6, yi / 40);
          // the trunk has to come in on screen, below the header
          var trunkY = y + TREE.trunk * h;
          if (trunkY < navH + 0.06 * h || trunkY > vh * 0.82) continue;
          var vis = 0, clash = false;
          for (var i = 0; i < n && !clash; i++) {
            var c = cells[2 * i], rr = cells[2 * i + 1];
            if (side === 'r') c = cols - 1 - c;
            var x0 = x + c * cw, y0 = y + rr * ch, x1 = x0 + cw, y1 = y0 + ch;
            if (x1 > bx0 && x0 < bx1 && y1 > by0 && y0 < by1) {
              for (var j = 0; j < obs.length; j++) {
                var o = obs[j];
                if (x1 > o.x0 && x0 < o.x1 && y1 > o.y0 && y0 < o.y1) { clash = true; break; }
              }
            }
            if (x1 > 0 && x0 < vw && y1 > navH && y0 < vh) vis++;
          }
          if (clash || vis < n * 0.55) continue;
          // most visible canopy wins; slight preference for trees that sit high, framing the top of the wall
          var score = vis * cw * ch * (1 - 0.3 * Math.abs(trunkY / vh - prefer));
          if (!best || score > best.score) best = { x: x, y: y, w: w, score: score };
        }
      }
    }
    if (!best) { // nothing fits (very unusual screens): small tree tucked in the top corner
      var w2 = wMin, h2 = w2 / TREE.aspect;
      best = { x: side === 'l' ? -0.35 * w2 : vw - 0.65 * w2, y: navH - 0.45 * h2, w: w2 };
    }
    return best;
  };

  // Scale a pose about the point where the trunk comes in at the screen edge (the trunk stays put, the canopy grows).
  // vw: the screen's width (fit mode: the room's frame)
  Hero.prototype.grow = function (side, pose, k, vw) {
    if (k === 1) return pose;
    if (vw == null) vw = this.vw;
    var h = pose.w / TREE.aspect, w = pose.w * k;
    var x = side === 'l' ? pose.x * k : vw - (vw - pose.x) * k;
    return { x: x, y: pose.y - TREE.trunk * h * (k - 1), w: w };
  };

  // How far tree t has to move along its push direction so no canopy cell covers product r (0 = already clear).
  Hero.prototype.clearance = function (t, r) {
    var grid = TREE.grid, rows = grid.length, cols = grid[0].length, cells = TREE.cells, n = cells.length / 2;
    // (fit mode: the margin and the step at the room's scale, 13 frame px as on a laptop)
    var hp = t.hero, w = hp.w, h = w / TREE.aspect, cw = w / cols, ch = h / rows, m = this.fit ? 13 * this.R.k : 14;
    var x0 = r.x0 - m, y0 = r.y0 - m, x1 = r.x1 + m, y1 = r.y1 + m, step = this.fit ? Math.max(1.5, 6 * this.R.k) : 6;
    for (var d = 0; d <= w * 1.2; d += step) {
      var ox = hp.x + t.dir[0] * d, oy = hp.y + t.dir[1] * d;
      if (ox + w < x0 || ox > x1 || oy + h < y0 || oy > y1) return d;
      var hit = false;
      for (var i = 0; i < n && !hit; i++) {
        var c = cells[2 * i];
        if (t.side === 'r') c = cols - 1 - c;
        var cx0 = ox + c * cw, cy0 = oy + cells[2 * i + 1] * ch;
        hit = cx0 + cw > x0 && cx0 < x1 && cy0 + ch > y0 && cy0 < y1;
      }
      if (!hit) return d;
    }
    return w * 1.2;
  };

  // The spring: target = the push that uncovers the piece being pointed at, eased in as the pointer gets close.
  Hero.prototype.updatePush = function (dt, y, pageT, enter) {
    var s = this.tl.scrollTrigger;
    var pinTop = y < s.start ? s.start - y : y > s.end ? s.end - y : 0; // the stage scrolls away after the pin
    var near = this.ptr && this.ptr.touch ? 90 : 150; // "about to hover" distance, px
    var on = enter > 0.5 && pageT < 1 && this.prods;
    // the side walls opening (or the view turning to them): both trees part to leave the displays clear
    var aside = this.hasSides ? Math.max(smooth(0, 0.5, this.sideOpen), this.pan ? Math.abs(this.cam.v) : 0) * (1 - pageT) : 0;
    for (var i = 0; i < 2; i++) {
      var t = this.trees[i], target = 0;
      if (on) {
        if (this.focusIdx >= 0) target = t.clear[this.focusIdx] || 0;
        else if (this.ptr) {
          for (var j = 0; j < this.prods.length; j++) {
            var c = t.clear[j];
            if (!c || (this.prods[j].el && this.prods[j].el.inert)) continue;
            var r = this.prods[j];
            var dx = Math.max(r.x0 - this.ptr.x, 0, this.ptr.x - r.x1);
            var dy = Math.max(r.y0 + pinTop - this.ptr.y, 0, this.ptr.y - (r.y1 + pinTop));
            var wgt = 1 - smooth(0, near, Math.sqrt(dx * dx + dy * dy));
            if (wgt > 0) target = Math.max(target, c * wgt);
          }
        }
        target *= 1 - pageT;
      }
      if (aside > 0 && t.sideClear) target = Math.max(target, t.sideClear * aside);
      // slightly under-damped: the branch swings aside, overshoots a touch and settles
      var acc = 70 * (target - t.pd) - 11 * t.pv;
      t.pv += acc * dt;
      t.pd += t.pv * dt;
    }
  };

  // after the hero: smaller than in the hero, partly off-screen at the sides, in the top corners just under the nav
  Hero.prototype.pagePose = function (side, hero) {
    var vw = this.vw, mobile = this.mobile;
    var w = (mobile ? Math.max(170, vw * 0.5) : clamp(vw * 0.27, 260, 540)) * this.pageScale;
    var h = w / TREE.aspect;
    var off = mobile ? 0.44 : 0.3;
    var x = side === 'l' ? -off * w : vw - w + off * w;
    var y = this.barH - 0.1 * h; // only the top tenth of the canopy sits under the glass nav
    return { x: x, y: y, w: w, s: w / hero.w };
  };

  // Past the hero the nav stays on screen: the theme's "on scroll up" header switches to its own always-sticky
  // mode (scrolling back into the hero hands it back, so the reveal stays full-screen).
  Hero.prototype.pinNav = function (on) {
    if (on === this.navPinned) return;
    this.navPinned = on;
    var sticky = document.querySelector('sticky-header');
    var header = document.querySelector('.section-header');
    document.documentElement.classList.toggle('otk-sakura-past', on);
    if (!sticky || !header) return;
    if (this.navAlways === undefined) this.navAlways = !!sticky.headerIsAlwaysSticky;
    if (this.navAlways) return; // the theme already keeps it up
    sticky.headerIsAlwaysSticky = on;
    if (on && header.classList.contains('scrolled-past-header')) {
      header.classList.add('shopify-section-header-sticky', 'animate');
      header.classList.remove('shopify-section-header-hidden');
    }
  };

  /* ------------------------------------------------ per frame */
  Hero.prototype.tick = function (time, deltaMs) {
    if (!this.tl) return;
    var dt = Math.min((deltaMs || 16.7) / 1000, 0.05);
    var y = this.lenis ? this.lenis.scroll : window.scrollY;
    var raw = this.lenis ? this.lenis.velocity : y - this.lastY;
    this.lastY = y;
    var v = Math.min(Math.abs(raw) / 40, 1);
    this.vel += (v - this.vel) * (v > this.vel ? 0.3 : 0.05); // quick to rise, slow to settle
    if (raw > 0.5) this.dir = 1;
    else if (raw < -0.5) this.dir = -1;
    this.stepRacks(dt, time, y);
    if (!this.trees) return;
    if (++this.frameCount % 90 === 0) this.maxScroll = window.ScrollTrigger.maxScroll(window);

    var end = this.tl.scrollTrigger.end, vh = this.vh;
    var after = clamp((y - end) / (vh * 0.7), 0, 1); // hero leaving the screen
    var pageT = easeInOut(after);
    // the trees' own way back to the page's corners (with the band under the room: once its buttons are past, layout)
    var treeT = this.band && this.bandDelay ? easeInOut(clamp((y - end - this.bandDelay) / (vh * 0.7), 0, 1)) : pageT;
    var bloom = clamp((y - end) / Math.max(vh, this.maxScroll - end - vh * 0.1), 0, 1); // 1 near the bottom
    var enter = easeOut(this.st.treeIn);
    var showing = enter > 0.001 || this.petals.length > 0;
    if (showing !== this.showing) {
      this.fx.classList.toggle('is-live', showing); // the layer stays hidden until trees or petals are in view
      this.showing = showing;
    }
    if (!showing) return;

    // trees
    this.updatePush(dt, y, treeT, enter);
    var gust = clamp(this.vel * this.dir * 1.6, -2, 2);
    // the rack's gusts reach the trees too (eased in and out; not once the hero has gone)
    var wnd = this.rack && this.rack.wind;
    var gt = wnd && wnd.on && pageT < 1 ? wnd.dir * wnd.str * wnd.fade * 1.4 : 0;
    this.gustS = (this.gustS || 0) + (gt - (this.gustS || 0)) * Math.min(1, dt * 2);
    gust = clamp(gust + this.gustS, -5, 5);
    for (var i = 0; i < 2; i++) {
      var t = this.trees[i], hp = t.hero, pp = t.page;
      var outX = t.side === 'l' ? -hp.w * 1.04 : this.vw + hp.w * 0.04;
      var x = lerp(outX, hp.x, enter), ty = hp.y, s = 1;
      if (this.keepTrees) {
        x = lerp(x, pp.x, treeT);
        ty = lerp(hp.y, pp.y, treeT);
        s = lerp(1, pp.s, treeT);
      } else {
        x = lerp(x, outX, treeT);
      }
      x += t.dir[0] * t.pd;
      ty += t.dir[1] * t.pd;
      // the gust's lean: a spring kicked when the door-open gust carries the tree in
      t.leanV = (t.leanV || 0) + (-26 * (t.lean || 0) - 3.4 * (t.leanV || 0)) * dt;
      t.lean = (t.lean || 0) + t.leanV * dt;
      var sway = Math.sin(time * 0.55 + t.phase) * 1.1 + Math.sin(time * 1.37 + t.phase * 2.3) * 0.35 + gust + t.lean;
      sway -= (t.pd / hp.w) * 9; // a pushed branch also lifts
      if (t.side === 'r') sway = -sway;
      t.el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + ty.toFixed(1) + 'px,0) scale(' + s.toFixed(4) + ')';
      t.sway.style.transform = 'rotate(' + sway.toFixed(3) + 'deg)';
      t.pose = { x: x, y: ty, w: hp.w * s, h: hp.w * s / TREE.aspect, sway: sway };
    }

    // blossoms: full -> half -> bare with page progress (only once the later images are in)
    var b = this.laterReady ? bloom : 0;
    var fullO = 1 - smooth(0.02, 0.5, b), halfO = 1 - smooth(0.5, 0.97, b);
    if (Math.abs(fullO - this.bloomShown) > 0.003 || Math.abs(halfO - this.halfShown) > 0.003) {
      for (var q = 0; q < 2; q++) {
        this.trees[q].full.style.opacity = fullO.toFixed(3);
        this.trees[q].half.style.opacity = halfO.toFixed(3);
      }
      this.bloomShown = fullO;
      this.halfShown = halfO;
    }

    this.updatePetals(dt, time, enter, after, b);
  };

  Hero.prototype.updatePetals = function (dt, time, enter, after, bloom) {
    var ctx = this.ctx, dpr = this.dpr, W = this.cw, H = this.ch, P = this.petals;
    // emission: canopy is in, scroll speed boosts it, and it runs out with the blossoms
    var flow = this.st.petalIn * (1 - bloom) * (enter > 0.98 ? 1 : 0);
    var base = (this.mobile ? 1.3 : 2.6) * this.density; // petals per second per tree at rest
    var rate = base * flow * (0.4 + 3.2 * this.vel);
    var pts = bloom < 0.45 ? TREE.full : TREE.half;
    for (var i = 0; i < 2; i++) {
      var t = this.trees[i];
      // a branch swinging aside shakes a few extra petals loose
      var shake = enter > 0.98 ? Math.min(Math.abs(t.pv) / (0.3 * t.hero.w), 1.5) * (this.mobile ? 8 : 18) * (1 - bloom) * this.density / 4 : 0;
      t.acc = (t.acc || 0) + (rate + shake) * dt;
      while (t.acc >= 1) {
        t.acc -= 1;
        if (P.length >= this.limit) { t.acc = 0; break; }
        this.spawn(t, pts);
      }
    }
    // the door-open gust: a rush of blossoms streams in from upwind, and its wind carries every petal for a moment
    // (fit mode: the petals' sizes, speeds and the wind are scaled with the room: pk)
    var bw = 0, b = this.burst, pk = this.pk || 1;
    if (b) {
      b.age += dt;
      bw = b.dir * 620 * pk * Math.min(1, b.age / 0.25) * Math.exp(-Math.max(0, b.age - 0.25) / 1.1);
      if (b.age < 1.2) {
        b.acc += b.total / 1.2 * dt;
        while (b.acc >= 1) { b.acc -= 1; if (P.length < this.limit * 1.4) this.spawnGust(b); }
      }
      if (b.age > 3.4) this.burst = null;
    }
    if (!P.length) {
      if (this.drawn) { ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, this.canvas.width, this.canvas.height); this.drawn = false; }
      return;
    }

    var boost = this.vel * 2.4;
    var wind = ((8 + 30 * this.vel) * (this.dir > 0 ? 1 : -0.6) + Math.sin(time * 0.3) * 6) * pk + bw;
    var soften = (1 - this.contentAlpha) * after; // petals over the page content are softened
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    var S = 48, half = S / 2;
    for (var j = P.length - 1; j >= 0; j--) {
      var p = P[j];
      p.ph += dt * p.freq;
      var vyT = p.fall * (1 + boost);
      var vxT = wind * p.drag + Math.sin(p.ph) * p.amp;
      p.vy += (vyT - p.vy) * Math.min(1, dt * 2.2);
      p.vx += (vxT - p.vx) * Math.min(1, dt * 1.6);
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      p.rot += p.spin * dt * (1 + boost * 0.6);
      p.flip += p.flipV * dt * (1 + boost * 0.4);
      p.age += dt;
      if (p.y > H + 30 || p.x < -40 || p.x > W + 40) { P[j] = P[P.length - 1]; P.pop(); continue; }
      var a = p.alpha * Math.min(1, p.age * 3);
      if (soften > 0) {
        var xr = p.x / W;
        a *= 1 - soften * smooth(0.06, 0.2, xr) * (1 - smooth(0.8, 0.94, xr));
      }
      var cs = Math.cos(p.rot), sn = Math.sin(p.rot), fl = Math.cos(p.flip);
      fl = fl < 0 ? Math.min(fl, -0.18) : Math.max(fl, 0.18);
      var sc = (p.size / S) * dpr;
      ctx.globalAlpha = a;
      ctx.setTransform(cs * fl * sc, sn * fl * sc, -sn * sc, cs * sc, p.x * dpr, p.y * dpr);
      ctx.drawImage(p.sprite, -half, -half);
    }
    ctx.globalAlpha = 1;
    this.drawn = true;
  };

  Hero.prototype.spawn = function (t, pts) {
    var pose = t.pose;
    if (!pose) return;
    var n = pts.length / 2;
    for (var tries = 0; tries < 5; tries++) {
      var k = (Math.random() * n) | 0, px = pts[2 * k], py = pts[2 * k + 1];
      if (t.side === 'r') px = 1 - px;
      var x = pose.x + px * pose.w, y = pose.y + py * pose.h;
      if (x < -10 || x > this.cw + 10 || y < this.navH * 0.5 || y > this.ch - 20) continue;
      this.petals.push(this.petal(x, y, 0.75 + 0.25 * pose.w / t.hero.w));
      return;
    }
  };

  // a petal of the door-open gust: most come in from the upwind edge, some off the arriving trees, all moving fast
  Hero.prototype.spawnGust = function (b) {
    var p;
    if (Math.random() < 0.4 && this.trees) {
      var n0 = this.petals.length;
      this.spawn(this.trees[(Math.random() * 2) | 0], TREE.full);
      if (this.petals.length === n0) return;
      p = this.petals[this.petals.length - 1];
    } else {
      // (fit mode: across the room's height, not the screen's)
      var gy = this.fit && this.R ? this.R.y + this.R.h * (0.1 + 0.78 * Math.random()) : this.ch * (0.1 + 0.78 * Math.random());
      p = this.petal(b.dir > 0 ? -12 : this.cw + 12, gy, 1);
      this.petals.push(p);
    }
    var pk = this.pk || 1;
    p.vx = b.dir * (380 + Math.random() * 360) * pk;
    p.vy = (10 + Math.random() * 50) * pk;
    p.age = 0.25; // already in the air: no fade-in
  };

  Hero.prototype.petal = function (x, y, scale) {
    // (fit mode: scaled with the room, pk, instead of the phones' 0.7)
    var pk = this.fit ? this.pk || 1 : 1, big = this.fit ? pk : this.mobile ? 0.7 : 1;
    return {
      x: x, y: y, vx: 0, vy: 8 * pk,
      size: (7 + Math.random() * 7) * big * scale,
      fall: (34 + Math.random() * 30) * pk,
      drag: 0.6 + Math.random() * 0.6,
      amp: (14 + Math.random() * 22) * pk,
      freq: 1.1 + Math.random() * 1.4,
      ph: Math.random() * 6.28,
      rot: Math.random() * 6.28,
      spin: (Math.random() - 0.5) * 3.2,
      flip: Math.random() * 6.28,
      flipV: 1.6 + Math.random() * 2.6,
      alpha: 0.72 + Math.random() * 0.26,
      age: 0,
      sprite: this.sprites[(Math.random() * this.sprites.length) | 0]
    };
  };

  Hero.prototype.destroy = function () {
    var gsap = window.gsap;
    if (this.tl) {
      if (this.tl.scrollTrigger) this.tl.scrollTrigger.kill(true);
      this.tl.kill();
    }
    if (gsap) gsap.ticker.remove(this.tick);
    if (gsap) gsap.ticker.remove(this.litTick);
    this.litWrite(null);
    if (this.gustCall) this.gustCall.kill();
    clearTimeout(this.litWakeT);
    if (this.navPinned) this.pinNav(false);
    if (this.onRefresh && window.ScrollTrigger) window.ScrollTrigger.removeEventListener('refresh', this.onRefresh);
    if (this.litRefresh && window.ScrollTrigger) window.ScrollTrigger.removeEventListener('refresh', this.litRefresh);
    this.listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
    if (this.fx && this.fx.parentNode && !this.root.contains(this.fx)) this.fx.remove();
    if (this.titlebar && this.titlebar.parentNode && !this.root.contains(this.titlebar)) this.titlebar.remove();
    this.dead = true;
    if (this.viewObs) this.viewObs.disconnect();
    document.documentElement.classList.remove('otk-sakura-viewing', 'otk-sakura-sides');
    if (this.rack) this.rack.destroy(); // frees its GL contexts (the theme editor re-mounts sections often)
    this.racks.forEach(function (r) { if (r.api && r.api.destroy) r.api.destroy(); });
    this.root._otkSakura = null;
    if (window.ScrollTrigger) window.ScrollTrigger.refresh();
  };

  function debounce(fn, ms) {
    var id;
    return function () { clearTimeout(id); id = setTimeout(fn, ms); };
  }

  function boot(root) {
    if (root._otkSakura) return;
    try {
      new Hero(root);
    } catch (err) {
      // never leave the door shut over the products
      root.classList.add('is-static');
      if (window.console) console.error('[otk-sakura]', err);
    }
  }

  function init() {
    document.querySelectorAll('[data-otk-sakura]').forEach(boot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-otk-sakura]');
    if (r) boot(r);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('[data-otk-sakura]');
    if (r && r._otkSakura) r._otkSakura.destroy();
  });
})();
